import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResponsiveModal from '../ui/ResponsiveModal';

const QualityDefinitionModal = ({
  isOpen,
  onClose,
  onSave,
  initialData = null,
  hotels = [],
  departments = [],
}) => {
  const [dfNo, setDfNo] = useState('');
  const [year, setYear] = useState('');
  const [hotelId, setHotelId] = useState('');
  const [department, setDepartment] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset';
      return;
    }

    document.body.style.overflow = 'hidden';
    setDfNo(initialData?.df_no || '');
    setYear(initialData?.year || '');
    setHotelId(initialData?.hotel_id ? String(initialData.hotel_id) : (hotels[0]?.id ? String(hotels[0].id) : ''));
    setDepartment(initialData?.department_id ? String(initialData.department_id) : '');
    setError('');

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, initialData, hotels]);

  useEffect(() => {
    if (!department) return;
    const selected = departments.find((item) => String(item.id) === String(department));
    if (selected && hotelId && String(selected.hotel_id) !== String(hotelId)) {
      setDepartment('');
    }
  }, [hotelId, department, departments]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dfNo.trim()) {
      setError('Duzeltici Faaliyet numarasi zorunludur.');
      return;
    }
    if (!hotelId) {
      setError('Otel seçimi zorunludur.');
      return;
    }

    await onSave({
      df_no: dfNo.trim(),
      hotel_id: Number(hotelId),
      department_id: department ? Number(department) : null,
      year: year ? Number(year) : null,
    });
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          {initialData ? 'Duzeltici Faaliyet Tanimi Duzenle' : 'Yeni Duzeltici Faaliyet Tanimi'}
        </h2>
        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        {error && <div className="text-sm text-red-600 dark:text-red-400">{error}</div>}
        <select
          value={hotelId}
          onChange={(e) => setHotelId(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
        >
          <option value="">Otel seçiniz</option>
          {hotels.map((item) => (
            <option key={item.id} value={item.id}>{item.hotel_name}</option>
          ))}
        </select>
        <input
          value={dfNo}
          onChange={(e) => setDfNo(e.target.value)}
          placeholder="Duzeltici Faaliyet Numarasi"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <input
          type="number"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          placeholder="Yil (opsiyonel)"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <select
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
        >
          <option value="">Departman (opsiyonel)</option>
          {departments.filter((item) => !hotelId || String(item.hotel_id) === hotelId).map((item) => (
            <option key={item.id} value={item.id}>{item.department_name}</option>
          ))}
        </select>
        <div className="flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-200">
            Iptal
          </button>
          <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm">
            {initialData ? 'Guncelle' : 'Kaydet'}
          </button>
        </div>
      </form>
    </ResponsiveModal>
  );
};

export default QualityDefinitionModal;
